import React, { createRef, useState } from "react";
import styles from "./BodyMapManager.module.css";
import BodyMap from "./BodyMap";
import BodyMapPanel from "./BodyMapPanel";
import FileUploaderModal from "../FileUploaderModal/FileUploaderModal";
import BodyMapService from "../../Services/bodyMapService";
import { useDeletionConfirmationModal } from "../../Hooks/DeletionConfirmationModal";
import noteIcon from "../../Assets/Icons/note.png";
import { usePrivileges } from "../../Context/PrivilegeContext";
import PrivilegeValidationService from "../../Services/privilegeValidationService";
import { useToasts } from "../../LayoutComponents/ToastContext";
import i18n from "../../Services/i18n";

function BodyMapManager({ reloadDetail, initialMaps = [], cltId, horseId, soId, lockParent }) {
  const fileUploadModal = createRef();
  const { privileges } = usePrivileges();
  const { addToast } = useToasts();

  const [lockPanel, setLockPanel] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [selectedBodyMap, setSelectedBodyMap] = useState();

  const confirmDelete = useDeletionConfirmationModal();
  const handleAdd = async () => {
    if (!PrivilegeValidationService.HorseCanAddBodyMap(await privileges(), initialMaps.length)) {
      addToast(i18n.t("Privilege.ValidationError.MaxBodyMapByHorse"), "PrivilegeValidationFailed", "ERROR", true);
      return;
    }
    fileUploadModal.current.open();
  };

  const handleSelectBodyMap = async (id) => {
    const bM = await BodyMapService.Get(id);
    setSelectedBodyMap(bM);
    setSelectedId(id);
  };

  const handleDelete = async (bM) => {
    confirmDelete({
      entityId: bM.externalId,
      entityImage: bM.defaultImage,
      icon: noteIcon,
      entityTitle: "BodyMap",
      deleteFunction: async () => await BodyMapService.Delete(bM.externalId),
      onClose: async () => {
        setSelectedId(null);
        reloadDetail();
      },
    });
  };

  const handleSaveBodyMap = async (pins) => {
    const bM = {
      ExternalId: selectedBodyMap.externalId,
      clientExternalId: selectedBodyMap.clientExternalId,
      Pins: pins.map((p) => {
        const dto = {
          id: p.id,
          x: p.x,
          y: p.y,
          color: p.color,
          size: p.size,
          isSticky: p.isSticky,
          note: p.note,
        };
        return dto;
      }),
    };

    await BodyMapService.Update(bM);
    handleSelectBodyMap(selectedBodyMap.externalId);
  };

  return (
    <div className={styles.wrapper}>
      <FileUploaderModal
        ref={fileUploadModal}
        showMultiImageTab={false}
        callback={async (thumbnail, fileId) => {
          const bodymap = {
            imageId: fileId,
            clientExternalId: cltId,
            horseExternalId: horseId,
            serviceOccurenceExternalId: soId,
            Pins: [],
          };
          await BodyMapService.Create(bodymap);
          reloadDetail();
        }}
        allowMultipleFiles={false}
      />
      <BodyMapPanel
        bodyMaps={initialMaps}
        selectedId={selectedId}
        onSelect={async (id) => await handleSelectBodyMap(id)}
        onDelete={async (bM) => await handleDelete(bM)}
        onAdd={handleAdd}
        isLocked={lockPanel}
      />
      <div className={styles.mainPanel}>
        {selectedBodyMap ? (
          <BodyMap
            imageUrl={selectedBodyMap.imageUrl}
            pins={selectedBodyMap.pins}
            lockParent={(lock) => {
              setLockPanel(lock);
              lockParent(lock);
            }}
            saveBodyMap={async (pins) => await handleSaveBodyMap(pins)}
          />
        ) : (
          <div className={styles.placeholder}>Aucun BodyMap sélectionné</div>
        )}
      </div>
    </div>
  );
}

export default BodyMapManager;
